import React, { useEffect, useState } from 'react';

const SidebarOptionTree = (props) => {
  const initialOpened = false;
  const [opened, setOpened] = useState(initialOpened);
  useEffect(() => {
    if (props.active === true) {
      setOpened(true);
    }
  }, [props.active]);

  let _trouglic = (e) => {
    // console.log('klik na trouglic');
    if (opened) {
      setOpened(false);
    } else {
      setOpened(true);
    }
  }

  let clActive = '';
  if (opened === true) {
    clActive = ' active';
  }

  let hasIcon = false;
  let jsxFontAwsome = null;
  jsxFontAwsome = (
    <span className="icon">
      <i></i>
    </span>
  );
  if (typeof props.i === 'string' && props.i !== '') {
    hasIcon = true;
    jsxFontAwsome = (
      <span className="icon">
        <i className={props.i} aria-hidden="true"></i>
      </span>
    )
  }

  let jsx = null;
  if (props.condition === true) {
    jsx = props.children;
  }

  return (
    <div className={"option-tree" + clActive}>
      <div
        className="option-tree-header"
        onClick={_trouglic}
      >
        <div className="bg">{jsxFontAwsome}<span className="title">{props.title}</span><span className="unicompo-rotating-triangle__fig"><i className="fa fa-chevron-left" aria-hidden="true"></i></span></div>
      </div >
      <div className="option-tree-children">
        {props.children}
      </div>
    </div >
  );
};

export default SidebarOptionTree;